import React, { FC, ReactNode } from 'react'
import { List} from '@chakra-ui/react'

interface IBStepperProps {
  children: ReactNode;
  [x: string]: unknown;
}

const IBStepper: FC<IBStepperProps> = ({children, ...rest}) => (
  <List spacing={3} {...rest}>
    {children}      
  </List>
)

export default IBStepper